import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

export const attachmentKind = (nameOrUrl = "") => {
  const ext = String(nameOrUrl).split("?")[0].split(".").pop()?.toLowerCase();
  if (["png", "jpg", "jpeg", "gif", "webp", "bmp", "svg"].includes(ext)) return "image";
  if (ext === "pdf") return "pdf";
  return "other";
};

// In-app preview of a payment proof: image or PDF shown right in a dialog,
// with an "Open in new tab" fallback (and for file types a browser can't show).
export default function AttachmentPreviewDialog({ open, url, name, onClose }) {
  const kind = attachmentKind(name || url);
  return (
    <Dialog open={Boolean(open)} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", pr: 1 }}>
        <Typography sx={{ flex: 1, fontWeight: 700, fontSize: 16 }} noWrap title={name || ""}>
          {name || "Attachment"}
        </Typography>
        <IconButton onClick={onClose} size="small" aria-label="Close preview">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0, bgcolor: "#F4F6F8", minHeight: 320 }}>
        {kind === "image" && (
          <Box sx={{ display: "flex", justifyContent: "center", p: 2 }}>
            <Box
              component="img"
              src={url}
              alt={name || "Attachment"}
              sx={{ maxWidth: "100%", maxHeight: "70vh", objectFit: "contain", borderRadius: 1, bgcolor: "#fff" }}
            />
          </Box>
        )}
        {kind === "pdf" && (
          <Box component="iframe" src={url} title={name || "Attachment"} sx={{ width: "100%", height: "70vh", border: 0 }} />
        )}
        {kind === "other" && (
          <Box sx={{ p: 4, textAlign: "center" }}>
            <Typography color="text.secondary">
              A preview isn't available for this file type. Use "Open in new tab" to view or download it.
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button component="a" href={url} target="_blank" rel="noopener noreferrer" startIcon={<OpenInNewIcon />}>
          Open in new tab
        </Button>
        <Button onClick={onClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
